import React, { useEffect } from 'react'
import '../assets/styles/components/_login.scss'
import PasswordRecover from '../components/login/PasswordRecover'

const LoginCliente = () => {

  useEffect(() => {
    document.title = "Sección Clientes Tensolite";
  }, [])


  return (
    <div className="login-cliente__page">
      <div className='container'>
        <PasswordRecover />
      </div>
    </div>
  )
}

export default LoginCliente
